import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../lib/api';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const res = await axios.post(`${API}/auth/login`, { username, password });
      localStorage.setItem('auth_token', res.data.access_token);
      toast.success('Connexion réussie');
      navigate('/');
    } catch (error) {
      toast.error('Identifiants incorrects');
    } finally {
      setLoading(false);
    }
  };

  const handleVisitorMode = () => {
    navigate('/public');
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4">
      <div className="tactical-grid fixed inset-0 opacity-20" />
      
      <div className="relative z-10 w-full max-w-md">
        <div className="bg-[#0a0a0a] border border-[#262626] p-6 sm:p-8 corner-decoration relative">
          <div className="mb-6 sm:mb-8 text-center">
            <h1 className="font-primary font-black text-2xl sm:text-3xl tracking-tighter uppercase text-[#ff4500] mb-2">
              BLACK OPS 7
            </h1>
            <h2 className="font-primary font-black text-lg sm:text-xl tracking-tighter uppercase">
              TOURNAMENT
            </h2>
            <p className="font-secondary text-xs text-muted-foreground mt-2 tracking-wider">COMMAND CENTER ACCESS</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <label className="font-secondary text-xs uppercase text-muted-foreground block mb-2">Username</label>
              <input
                data-testid="username-input"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full bg-[#1f1f22] border-b border-white/10 focus:border-[#ff4500] px-4 py-3 text-sm font-secondary placeholder:text-muted-foreground/50 focus:outline-none transition-colors"
                placeholder="Entrez votre identifiant"
                required
              />
            </div>

            <div>
              <label className="font-secondary text-xs uppercase text-muted-foreground block mb-2">Password</label>
              <input
                data-testid="password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-[#1f1f22] border-b border-white/10 focus:border-[#ff4500] px-4 py-3 text-sm font-secondary placeholder:text-muted-foreground/50 focus:outline-none transition-colors"
                placeholder="Entrez votre mot de passe"
                required
              />
            </div>

            <button
              data-testid="login-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full bg-[#ff4500] text-black font-bold uppercase tracking-widest px-8 py-4 hover:bg-[#ff4500]/90 transition-colors clip-corner font-secondary text-sm disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'CONNEXION...' : 'SE CONNECTER ADMIN'}
            </button>

            <div className="relative my-6">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-white/10"></div>
              </div>
              <div className="relative flex justify-center text-xs uppercase">
                <span className="bg-[#0a0a0a] px-4 font-secondary text-muted-foreground">OU</span>
              </div>
            </div>

            <button
              data-testid="visitor-mode-btn"
              type="button"
              onClick={handleVisitorMode}
              className="w-full border-2 border-[#00ff9d] text-[#00ff9d] font-bold uppercase tracking-widest px-8 py-4 hover:bg-[#00ff9d]/10 transition-colors font-secondary text-sm"
            >
              CONTINUER EN MODE VISITEUR
            </button>
          </form>

          <div className="mt-6 p-4 bg-[#1a1a1a] border border-[#262626]">
            <p className="font-secondary text-xs text-muted-foreground text-center mb-2">Mode Visiteur :</p>
            <p className="font-secondary text-xs text-center">Accès lecture seule aux tournois, classement et guide CDL sans connexion</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;